import React, { useState, useCallback } from "react";
import { useStateWithCallbackLazy } from "use-state-with-callback";
import { withRouter } from "react-router";
import DataDisplay from "../components/DataDisplay";
import Loading from "../components/Loading";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";

import { getAssetLocationList, getAssetByRegId, getAssetByBarcode, updateAssetRegDetail } from "../services/api";

const AssetDisplay = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [loadingBtn, setIsLoadingBtn] = useState(false);
  const [data, setData] = useStateWithCallbackLazy(null);
  const [locationList, setLocationList] = useState(null);
  const [oldData, setOldData] = useState(null);

  const onInfoFetched = useCallback(async (barcodeOrRegId, searchType, mounted) => {
    if (!searchType) {
      const response = await getAssetByBarcode(barcodeOrRegId);
      //get first item when found if not found setData === undefined
      if (response.Data[0]) {
        const r = await getAssetLocationList();
        if (r) {
          setLocationList(r.Data);
          let objLoc = r.Data.find((item) => item.LocCode === response.Data[0].LocationCode);
          response.Data[0].objLoc = objLoc ?? "";
        }
      }
      setData(response.Data[0]);
      setOldData(response.Data[0]);
      if (mounted) {
        setIsLoading(false);
      }
    } else {
      const response = await getAssetByRegId(barcodeOrRegId);
      //get first item when found if not found setData === undefined
      if (response) {
        const r = await getAssetLocationList();
        if (r) {
          setLocationList(r.Data);
          let objLoc = r.Data.find((item) => item.LocCode === response.LocationCode);
          response.objLoc = objLoc ?? "";
        }
        setData(response);
        setOldData(response);
      } else {
        setData(undefined);
        setOldData(undefined);
      }
      if (mounted) {
        setIsLoading(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const UpdateData = (e, keyName) => {
    if (typeof e === "object" && keyName === "LocCode") {
      setData((prevState) => ({
        ...prevState,
        objLoc: e,
        LocationCode: e[keyName],
        // TransferDate: new Date(),
      }));
    } else {
      setData((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const UploadImg = (e) => {
    //var d = URL.createObjectURL(e.target.files[0]);
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      setData(
        (prevState) => ({
          ...prevState,
          AstPhoto: base64String,
        }),
        (nextState) => SaveData(e, nextState)
      );
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  const SaveData = async () => {
    // if (e.target.name === "AstPhoto") {
    //   const { Code, UserMessage } = await updateAssetRegDetail(newData);
    //   if (Code === 0) {
    //     toast.success(`💾 Save ${UserMessage}`, {
    //       position: "bottom-center",
    //       autoClose: 2000,
    //       hideProgressBar: true,
    //       closeOnClick: true,
    //       pauseOnHover: false,
    //       draggable: true,
    //       progress: undefined,
    //     });
    //   }
    //   return;
    // }
    setIsLoadingBtn(true);
    //update transfer date when change location
    if (oldData.LocationCode !== data.LocationCode) {
      data.TransferDate = new Date();
    }

    const { Code, UserMessage } = await updateAssetRegDetail(data);
    if (Code === 0) {
      toast.success(`💾 Save ${UserMessage}`, {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
    }

    setTimeout(() => {
      setIsLoadingBtn(false);
    }, 2000);
    // if (oldData[e.target.name] !== data[e.target.name]) {
    //   if (e.target.value !== "") {
    //     const { Code, UserMessage } = await updateAssetRegDetail(data);
    //     if (Code === 0) {
    //       toast.success(`💾 Save ${UserMessage}`, {
    //         position: "bottom-center",
    //         autoClose: 2000,
    //         hideProgressBar: true,
    //         closeOnClick: true,
    //         pauseOnHover: false,
    //         draggable: true,
    //         progress: undefined,
    //       });
    //     }
    //   }
    // }
  };

  React.useEffect(() => {
    let mounted = true;
    const params = new URLSearchParams(props.location.search);
    const searchType = Boolean(params.get("regId"));
    onInfoFetched(props.match.params.id, searchType, mounted);
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isLoading ? <Loading /> : ""}
      {/* Example id===0 for not found */}
      {data !== null ? (
        <DataDisplay
          code={props.match.params.id}
          loadingBtn={loadingBtn}
          data={data}
          UploadImg={UploadImg}
          UpdateData={UpdateData}
          SaveData={SaveData}
          locationList={locationList}
        />
      ) : (
        ""
      )}
      <ToastContainer />
    </>
  );
};

export default withRouter(AssetDisplay);
